import React, { createContext, FC, ReactNode, useContext, useState } from 'react';

type TopToolbarContextType = {
  topToolbarAdditionalContent?: ReactNode;
  setTopToolbarAdditionalContent: (content: ReactNode) => void;
  overridePageName?: string;
  setOverridePageName: (pageName?: string) => void;
};

const TopToolbarContext = createContext<TopToolbarContextType>({
  topToolbarAdditionalContent: undefined,
  setTopToolbarAdditionalContent: (): void => {
    throw new Error('setTopToolbarAdditionalContent function is not defined');
  },
  overridePageName: undefined,
  setOverridePageName: (): void => {
    throw new Error('setOverridePageName function is not defined');
  },
});

export const TopToolbarProvider: FC = ({ children }): JSX.Element => {
  const [topToolbarAdditionalContent, setTopToolbarAdditionalContent] = useState<ReactNode>();
  const [overridePageName, setOverridePageName] = useState<string | undefined>();
  return (
    <TopToolbarContext.Provider
      value={{ topToolbarAdditionalContent, setTopToolbarAdditionalContent, overridePageName, setOverridePageName }}
    >
      {children}
    </TopToolbarContext.Provider>
  );
};

export const useTopToolbarContext = (): TopToolbarContextType => useContext(TopToolbarContext);
